export const authService = {
  login (body) {
    return axios.post('auth/login', body)
      .then(res => {
        return res
      })
  },
  getUserData () {
    return axios.get('me')
      .then(res => {
        return res
      })
  },
  getExternalProfile (id) {
    return axios.get(`admin/users/${id}`)
      .then(res => {
        return res
      })
  },
  updateExternalUser (id, data) {
    return axios.patch(`admin/users/${id}`, data)
      .then(res => {
        return res
      })
  },
  updateProfile (body) {
    return axios.put('me', body)
      .then(res => {
        return res
      })
  },
  changePassword (body) {
    return axios.put('me/updatePassword', body)
      .then(res => {
        return res
      })
  },
  getRoles (id) {
    return axios.get(`o/1/roles`)
      .then(res => {
        return res
      })
  }
}
